export default __webpack_public_path__ + "static/media/Neophyte's Robes of Imperial Assent.ef29179c.jpg";